module.exports = __webpack_public_path__ + "img/D2-2-2-img01.51c0d61e.jpg";